import { useAuthContext } from "@contexts/auth";
import { combineMetricEnvelopes, metricEnvelopeFor } from "@utils/metricPresentation";
import { Fragment } from "react";
import { renderMetricCard } from "./defaults";

const MainCards = ({ item }) => {
  const { user: { configurations: { offcanvas: { cards } } } } = useAuthContext();

  const checkFilteredPath = () => {
    if (window.location.pathname.includes('projecao-financeira')) return true;
    return false;
  }

  const itemReasonKey = String(item?.wbs_code_id ?? item?.building_unit_id ?? item?.id ?? "selected")
    .replace(/[^a-zA-Z0-9_-]/g, "-");
  const metricCard = (label, metricKey, legacyKey = metricKey) => renderMetricCard(
    label,
    metricEnvelopeFor(item, metricKey, legacyKey),
    `metric-offcanvas-${itemReasonKey}-${metricKey}-reason`,
  );
  const hasExtraValues = Array.isArray(item?.extraValue);
  const extraValues = hasExtraValues ? item.extraValue : [];
  const extraValuesValid = hasExtraValues && extraValues.every(({ value }) => (
    typeof value === "number" && Number.isFinite(value)
  ));
  const extraEnvelope = {
    id: "extraValue",
    value: extraValuesValid ? extraValues.reduce((sum, { value }) => sum + value, 0) : null,
    unit: "BRL",
    status: extraValuesValid ? "ok" : hasExtraValues ? "degraded" : "source_unavailable",
  };

  const checkCard = (i) => {
    switch (i) {
      case 'commited':
        return metricCard('Comprometido (R$)', 'committed', 'commited')
      case 'paid':
        return checkFilteredPath() ? metricCard('Pago (R$)', 'filteredPaid') : metricCard('Pago (R$)', 'paid')
      case 'toPay':
        return checkFilteredPath() ? metricCard('A pagar (R$)', 'filteredToPay') : metricCard('A pagar (R$)', 'toPay')
      case 'budget':
        return metricCard('Orçado (R$)', 'budget')
      case 'measured':
        return metricCard('Medido (R$)', 'measured')
      case 'predicted':
        return metricCard('Previsto (R$)', 'predicted')
      case 'baseline':
        return metricCard('Linha de base (R$)', 'baseline')
      case 'trend':
        return metricCard('Tendência (R$)', 'trend')
      case 'idc':
        return metricCard('IDC', 'idc')
      case 'extraValue':
        return renderMetricCard('Estouro / Economia (R$)', extraEnvelope, `metric-offcanvas-${itemReasonKey}-extraValue-reason`)
      case 'extraCommited':
        return renderMetricCard(
          'Comprometido + Estouros / Economias (R$)',
          combineMetricEnvelopes(
            [metricEnvelopeFor(item, 'committed', 'commited'), extraEnvelope],
            ([committed, extra]) => committed + extra,
            { id: 'extraCommitted', unit: 'BRL' },
          ),
          `metric-offcanvas-${itemReasonKey}-extraCommitted-reason`,
        )
      case 'stock':
        return metricCard('Em Estoque (R$)', 'stockValue')
      case 'stockTrend':
        return metricCard('Tendência com Estoque (R$)', 'stockTrend')
      default:
        break;
    }
  }

  return <>
    <h3>Dados complementares</h3>
    <div className="grid gap-24 columns-2-tablet columns-3-laptop-l margin-top-24">
      {cards.map(i => {
        return <Fragment key={i}>{checkCard(i)}</Fragment>
      })}
    </div>
  </>
}

export default MainCards;
